/* src/app/pages/doctores/formdoctores/formdoctores.component.scss */
/*# sourceMappingURL=formdoctores.component.css.map */
